//获取动态的config文件
let config;
if (sessionStorage.getItem("config")) {
  config = JSON.parse(sessionStorage.getItem("config"))
} else {
  alert("未能加载配置文件")
}


import Vue from 'vue'
import VueRouter from 'vue-router'

/******  系统基础路由(开始) ******/

//登陆页面
import Login from '../views/Login.vue'
//系统默认首页
import Home from '../components/home/home.vue'
//个人中心
import Mine from '../components/user/mine.vue'

//二维码扫码页面
import codeScanning from '../components/qrCode/codeScanning.vue'

/******  系统基础路由(结束) ******/



Vue.use(VueRouter)

//基础路由
const BaseRouter = [{
  path: '/Login',
  name: 'Login',
  component: Login
}, {
  path: '/Home',
  name: 'Home',
  component: Home
}, {
  path: '/Mine',
  name: 'Mine',
  component: Mine
},
{
  path: '/codeScanning',
  name: 'codeScanning',
  component: codeScanning
},
]


const routes = [...BaseRouter]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(function(to, from, next) {
  let v = new Vue()
  v.$utils.getAccessToken()
  //设置返回路由
  if (!to.params.hasOwnProperty("backUrl")) {
    to.params["backUrl"] = from.fullPath
  }

  next()

})


if (config && config["ServiceList"] && Array.isArray(config["ServiceList"])) {
  let apiModel = {}
  let routesList = []
  config["ServiceList"].forEach(function(item) {
    import("@/components/service/" + item + "/serviceRouter.js").then((module) => {
      let list = module.default;
      //导入当前服务的组件引入文件
      import("@/components/service/" + item + "/serviceConfig.js").then((configModel) => {
        //处理单服务组件注册
        //处理每个模块的api暴露
        if (configModel.default.hasOwnProperty("apiModel")) {
          //获得设置的api对象
          let keyStr = item.replace("service", "s") + "Apis"
          apiModel[keyStr] = configModel.default["apiModel"]
        }
        //将当前组件的列表添加到路由列表中
        router.addRoutes(list);
      }).catch(() => {
        //将当前组件的列表添加到路由列表中
        router.addRoutes(list);
        console.log(item + "的serviceConfig.js不存在");
      })

      // routesList = [...routesList,...list]
      // console.log(routesList);
      list.forEach(function(lItem) {
        routesList.push(lItem)
      })

    });
  })
  Vue.prototype.$serviceRoute = routesList
  Vue.prototype.$apis = apiModel
}


// 解决两次访问相同路由地址报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



export default router
